import { ContextStylesParams, CSSObject } from '@mantine/core'

const baseStyle = {
    border: '0.1rem solid inherit',
    fontFamily: 'var(--fira-font-semibold)'
}

const SIZES: Record<string, CSSObject> = {
    xs: { ...baseStyle, height: '3rem', padding: '0px 1.4rem' },
    sm: { ...baseStyle, height: '3.6rem', padding: '0px 1.8rem' },
    md: { ...baseStyle, height: '4.2rem', padding: '0px 2.2rem' },
    lg: { ...baseStyle, height: '5rem', padding: '0px 2.6rem' },
    xl: { ...baseStyle, height: '6rem', padding: '0px 3.2rem' }
}

export const getButtonStyles = (props: ContextStylesParams): Record<string, CSSObject> => {
    const style = SIZES[props?.size] || {}

    return {
        root: {
            ...style,
            ':disabled': {
                backgroundColor: 'var(--mantine-bg-disabled)',
                color: 'var(--mantine-text-disabled)'
            }
        }
    }
}
